// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__PB50h","body":"layout_body__8VXDr","project":"layout_project__rj9oR","label":"layout_label__qdcru","select":"layout_select__YTGhu"};